/**
 * useIsPlatformStaff (SYN-1504) — presentation gate for engine links.
 *
 * True only when the signed-in user holds a real Clerk membership in the
 * SynapseDx org (VITE_PLATFORM_STAFF_ORG_ID). Unset env = nobody is staff.
 * Viewer-mode org entries (platform admin viewing a non-member org) are NOT
 * memberships and do not count.
 */

import { useOrgContext } from "../providers/OrgProvider";
import { derivePlatformStaff, getPlatformStaffOrgId } from "../lib/platform-staff";

export function useIsPlatformStaff(): boolean {
  const { organizations } = useOrgContext();
  const membershipOrgIds = organizations.filter((org) => !org.isViewer).map((org) => org.orgId);
  return derivePlatformStaff(membershipOrgIds, getPlatformStaffOrgId());
}
